import { QUERY_KEYS } from 'api/query-keys';
import { workersPoolsService } from 'ogp/services';
import { useMutation, useQueryClient } from 'react-query';

export const useDeleteWorkersPool = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (workersPoolId: string) =>
    await workersPoolsService.deleteWorkersPool(workersPoolId);

  return useMutation(mutationFn, {
    onSettled: async () => {
      queryClient.invalidateQueries(QUERY_KEYS.flexPools());
    },
  });
};
